export default {
  list: {
    labels: {
      season: "Sezon",
      language: "Język",
      languageVersion: "Zawiera wersję językową",
      languages: {
        en: "Angielski",
        pl: "Polski",
        ae: "Arabski",
      },
      draft: "Wersja robocza",
      publishAt: "Zaplanowano datę publikacji",
      live: "Sesja live",
    },
    headers: {
      id: "ID",
      slug: "Slug",
      name: "Nazwa serii",
      published: "Opublikowany",
      season: "Sezon",
      language: "Język",
    },
  },
  dialog: {
    editSerie: "Edytuj serię",
    addSerie: "Dodaj nową serię",
    warning: "Uwaga!",
    videoWarning: "Ta seria nie ma dodanego żadnego video.",
  },
  form: {
    messages: {
      info: "Dodajesz wersję językową do serii",
    },
    step1: {
      title: "Seria",
      slug: "Slug link ID",
      slugDescription:
        "Opcjonalnie, w przypadku braku, system sam uzupłeni identyfikator na podstawie tytułu.",
      name: "Nazwa serii",
      childFor: "Wybierz serię, do której należy",
      parentSwitch: "Wersja językowa innej serii",
      parent: "Wybierz serię, do której tworzysz wersję językową",
      parentSubtitle: "(jeśli nie jest to pierwszy sezon)",
      language: "Wybierz język",
      isInspiration: "Jest inspiracją",
      oneVideo: "Tylko jedno video",
      recommended: "Polecana seria",
      season: "Sezon",
      live: "Sesja live",
      strategicLesson: "Lekcja strategiczna",
      liveFrom: "Data rozpoczęcia",
      liveTo: "Data zakończenia",
      liveUrl: "Adres url",
      liveGoogle: "Link kalendarza Google",
      liveOutlook: "Link kalendarza Outlook",
    },
    step2: {
      title: "Opisy",
      description: "Opis serii",
      longDescription: "Długi opis serii",
    },
    step3: {
      title: "Pliki",
      cover: "Okładka serii",
      selectCover: "okładki serii",
      bigCover: "Duża okładka",
      selectBigCover: "dużą okładkę poziomą",
      selectVerticalCover: "okładkę pionową",
      horizontal: "Pozioma",
      vertical: "Pionowa",
      verticalCover: "Pionowa okładka",
      coverHorizontal: "Pozioma okładka",
      videoTrailer: "Video trailer",
      videoTrailerChoose: "video trailer serii",
      videoTrailerSubtitles: "Napisy do trailera",
      videoTrailerSubtitlesChoose: "napisów do trailera",
      videoTrailerSubtitlesEn: "Napisy angielskie do trailera",
      videoTrailerSubtitlesEnChoose: "napisów angielskich do trailera",
      videoSample: "Sample video",
      videoSampleChoose: "sampla video",
      videoSampleSubtitles: "Napisy do sampla",
      videoSampleSubtitlesChoose: "napisów do sampla",
      videoSampleSubtitlesEn: "Napisy angielskie do sampla",
      videoSampleSubtitlesEnChoose: "napisów angielskich do sampla",
      selectBigVerticalCover: "dużą okładkę pionową",
      selectBigCoverWeb: "dużą okładkę web",
      selectBigCoverMobile: "dużą okładkę mobile",
      workbook_vertical: "Workbook okładka pionowa",
      workbook_horizontal: "Workbook okładka pozioma",
      help: {
        closeButton: "Zamknij",
        apiField: "Pole API",
        usedInRoutes: "Używana w ścieżkach (routes)",
        usedInComponents: "Używana w komponentach",
        responsiveness: "Responsywność",
        fallback: "Fallback",
        additionalNotes: "Uwagi",
        notUsedWarning:
          "Ta okładka nie jest obecnie używana w frontendzie aplikacji.",
      },
    },
    step4: {
      title: "Ebook",
      ebook: "Wybierz ebook",
      selectEbook: "ebooka",
      name: "Nazwa",
      description: "Opis",
      ebookSwitch: "Dodaj ebooka",
    },
    step5: {
      title: "Autorzy",
      authors: "Wybierz autorów",
      addNewAuthor: "Dodaj nowego autora",
    },
    step6: {
      title: "Filmy",
      videos: "Wybierz video",
      addNewVideo: "Dodaj nowe video",
    },
    step7: {
      title: "Kategorie",
      categories: "Wybierz kategorie",
      addNewCategory: "Dodaj nową kategorię",
    },
    step8: {
      title: "Jakie problemy rozwiążesz",
      problems: "Jakie problemy rozwiążesz",
      addNew: "Dodaj nowy",
    },
    step9: {
      title: "Słowa kluczowe",
      info: "Słowa kluczowe zasilają wyszukiwarkę – użytkownik, który wpisze takie hasło, znajdzie tę serię. Zmiany zapisują się od razu i trafiają do wyszukiwarki.",
      add: "Dodaj słowo kluczowe",
      count: "Liczba słów kluczowych",
      filter: "Szukaj na liście",
      empty: "Brak słów kluczowych dla tej serii.",
      emptyFilter: "Brak słów kluczowych pasujących do wyszukiwania.",
      duplicate: "To słowo kluczowe jest już na liście.",
      saveError: "Nie udało się zapisać słowa kluczowego.",
      confirmDelete: "Usunąć?",
      yes: "Tak",
      no: "Nie",
      edit: "Edytuj",
      delete: "Usuń",
      columns: {
        lp: "Lp.",
        name: "Słowo kluczowe",
      },
      ai: {
        fetch: "Pobierz z AI",
        title: "Propozycje słów kluczowych",
        info: "Przejrzyj i popraw propozycje. Zapisane zostaną tylko hasła, które zostawisz na liście — resztę usuń.",
        remove: "Usuń propozycję",
        addRow: "Dodaj puste pole",
        empty: "Brak propozycji. Możesz dodać własne hasła poniżej.",
        toAccept: "Do zapisania",
        accept: "Akceptuj",
        reject: "Odrzuć",
        allDuplicates: "Wszystkie propozycje są już przypisane do tej serii.",
        fetchError: "Nie udało się wygenerować propozycji. Spróbuj ponownie.",
        pending:
          "Generujemy propozycje — to może potrwać kilka minut. Możesz w tym czasie pracować dalej, modal otworzy się sam.",
        timeout:
          "Generowanie trwa zbyt długo — sprawdź, czy działa worker kolejki, i spróbuj ponownie.",
        needsSavedSerie: "Najpierw zapisz serię — propozycje powstają na podstawie jej nazwy i opisu.",
        summary:
          "Dodano hasła: {added}. Pominięto jako duplikaty: {skipped}. Błędy zapisu: {failed}.",
      },
      dialog: {
        addTitle: "Dodaj słowo kluczowe",
        editTitle: "Edytuj słowo kluczowe",
        hint: "Jedno hasło na raz. Wpisz frazę tak, jak wpisze ją użytkownik w wyszukiwarce.",
        saveAndNext: "Zapisz i dodaj kolejne",
      },
    },
    buttons: {
      saveDraft: "Zapisz wersję roboczą",
      setPublishDate: "Ustaw datę publikacji",
      previousStep: "Wróć",
      nextStep: "Następny krok",
      publishNow: "Opublikuj teraz",
      save: "Zapisz",
      acceptPreview: "Zapisz i zatwierdź",
    },
  },
  whatProblemsSolve: {
    dialog: {
      editTitle: "Edytuj",
      addTitle: "Dodaj nowy",
      name: "Nazwa",
    },
  },
};
